import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import {
  Button,
  showNotification as shn,
  fetchStart as fs,
  fetchEnd as fe,
} from "react-admin";

import { startAllKiosks } from "../lib/serverCommands";
import { getStationId } from "../authProvider";

const handleClick = (
  selectedIds,
  { showNotification, fetchStart, fetchEnd }
) => {
  fetchStart();
  startAllKiosks(getStationId())
    .then(() => showNotification("notification.startOfSell"))
    .catch(err => {
      showNotification("notification.errorSending"); // TODO: message
      console.error("Error sending multiple start kiosk message", err);
    })
    .finally(fetchEnd);
};

const StartAllButton = ({ selectedIds, ...props }) => (
  <Button
    label="Tout Démarrer"
    onClick={() => handleClick(selectedIds, props)}
  />
);

const styles = () => ({
  container: {
    display: "flex",
  },
});

export default connect(
  null,
  {
    showNotification: shn,
    fetchStart: fs,
    fetchEnd: fe,
  }
)(withStyles(styles)(StartAllButton));



// WEBPACK FOOTER //
// ./src/components/startAllButton.js